/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2020-08-07 18:12:25
 * @LastEditors: 李方强
 */
/**
 * response 过滤器
 *
 * @export
 * @param {*} res
 * @returns
 */
export default function filterResponse(res) {
  if (res.status === 302) {
    console.log(window.location.href)
    if (window.location.href.indexOf('y.yunjiglobal.com') > -1) {
      window.location.href = 'http://customerserviceadmin-do-dev.yunjiglobal.com/xinyunweb/login'
    } else if (window.location.href.indexOf('xinyunadmin.yunjiglobal.com') > -1) {
      window.location.href = 'http://sso.yunjiglobal.com'
    } else if (window.location.href.indexOf('http://customerserviceadmin-do-dev.yunjiglobal.com') > -1) {
      window.location.href = 'http://customerserviceadmin-do-dev.yunjiglobal.com/xinyunweb/login'
    } else if (window.location.href.indexOf('openxinyun.yunjiglobal.com') > -1) {
      window.location.href = 'https://openxinyun.yunjiglobal.com/xinyunweb/login'
    } else if (window.location.href.indexOf('t-do-dev.yunjiglobal.com') > -1) {
      window.location.href = 'http://tsso.yunjiglobal.com'
    } else {
      window.location.href = 'http://sso.yunjiglobal.com'
    }
  }
  if (!res.data || !(res.data.errorCode === 0 || res.data.code === 0 || (res.data.data && res.data.data.retCode === 0)) || res.status !== 200) {
    // eslint-disable-next-line
    throw {
      response: res,
      status: res.status,
      request: res.request,
      responseText: res.data && (res.data.errorMessage || res.data.msg || res.data.data) ? res.data.errorMessage || res.data.msg || res.data.data.reason : '网络错误',
      errorCode: res.data && (res.data.errorCode || res.data.code) !== undefined ? res.data.errorCode || res.data.code : 1
    }
  }
  return {
    data: res.data.data,
    response: res
  }
}